<template>
<div class="chapter">
<div class="inner_page">
<p class="cover" id="page_3"><img alt="Front Cover of The Marvelwood Magicians" src="images/9781629799186_cover.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 000_Cover.vue?51036c10